import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import moment from "moment";
import AppTable from "components/AppTable/AppTable";
import { dateTimeFormat } from "constant/constant";

const TokenTable = props => {
  const { onSubmit, user } = props;
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setLoading(true);
    const { _id } = user;
    onSubmit(_id)
      .then(res => {
        if (res.status) setTableData(res.data);
      })
      .finally(() => setLoading(false));
  }, []);

  let columns = [
    {
      title: "Token",
      dataIndex: "token",
      key: "token",
      width: 120,
      ellipsis: true,
      render: text => {
        return <Typography.Paragraph copyable>{text}</Typography.Paragraph>;
      }
    },
    {
      title: "Added Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 100,
      render: (text, record) => {
        return moment(record.createdAt).format(dateTimeFormat);
      }
    }
  ];

  return <AppTable columns={columns} dataSource={tableData} loading={loading} pagination={false} rowKey={record => record.token} />;
};

export default TokenTable;
